// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1j76y","skip":"styles_skip__J5imd","generate":"styles_generate__10Fnw"};